<app-alert-box-component (OnButtonClick)="onAlertButtonClick($event)" (OnAlertClose)="closeAlert($event)"
  (OnAlertVisibility)="alertVisibility($event)" [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" [alertBodyText]="alertBodyText" [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText" [data]="alertBoxData" [bAlert]="bAlert"></app-alert-box-component>
<div *ngIf="!decisionSaveModel" class="save-model">
  <div *ngIf="!showtime">
    <table class="table table-stripe   ">
      <thead>
        <tr>
          <!-- <th scope="col">Auto Onboarding Time</th> -->
          <th scope="col">Invitation Validity</th>
          <th scope="col">Auto Onboarding Time</th>
          <th scope="col">Auto Onboarding Strategy</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <!-- <td>{{autoInitialValue?.autoOnboardingTime}}</td> -->
          <td>{{autoInitialValue?.invitationValidity}}</td>
          <td>{{autoInitialValue?.tat}}</td>
          <td> 
              <span *ngIf="autoInitialValue?.autoOnboardingStrategy === 1">Income AND Nationality AND Residency</span>
              <span *ngIf="autoInitialValue?.autoOnboardingStrategy === 2">Income OR Nationality OR Residency</span>
              <span *ngIf="autoInitialValue?.autoOnboardingStrategy === 3">Income AND (Nationality OR Residency)</span>
           </td>
          <td>
            <div (click)="timeVal(autoInitialValue?.autoOnboardingTime, autoInitialValue?.invitationValidity,autoInitialValue?.tat,autoInitialValue?.autoOnboardingStrategy)"
              class="btn btn-primary"> Update</div>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
  <div *ngIf="showtime">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
      <c-container fluid>
        <b>Update Time and Validity</b>
        <button [cNavbarToggler]="toolbarCollapseRef"></button>
        <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
          <c-navbar-nav class="me-auto mb-2 mb-lg-0">

          </c-navbar-nav>
          <form cForm class="d-flex" role="search">
            <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton
        (click)="goBackTomainScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
      <button cTooltip="Save" cTooltipPlacement="top" style="margin: 5px;" cButton
        (click)="timeValueUpdate()"><svg cIcon name="cilSave"></svg></button>
          </form>
        </div>
      </c-container>
    </c-navbar>
    <div class="row g-2 pt-4">
      <form [formGroup]="myForm2">
        <div class="row timeVal-css">
          <!-- <div class="col-md-4">
            <label>Auto OnboardingTime</label>
            <div class="table-view">
              <input class="form-control" max="999" onkeypress="if (this.value.length > 3)  return false;" type="number"  formControlName="autoOnboardingTime" />
            </div>
          </div> -->
          <div class="col-md-4">
            <label>Invitation Validity</label>
            <div class="table-view">
              <input class="form-control" max="999" onkeypress="if (this.value.length > 3)  return false;" type="number"  formControlName="invitationValidity" />
            </div>
          </div>
          <div class="col-md-4">
            <label>Auto Onboarding Time</label>
            <div class="table-view">
              <input class="form-control" max="999" onkeypress="if (this.value.length > 3)  return false;" type="number"  formControlName="tat" />
            </div>
          </div>
          <div class="col-md-4">
            <label>Auto Onboarding Strategy</label>
            <div class="table-view">
              <select cSelect class="multiple" formControlName="autoOnboardingStrategy"> 
                <option value="1">Income AND Nationality AND Residency</option>
                <option value="2">Income OR Nationality OR Residency</option>                
                <option value="3">Income AND (Nationality OR Residency)</option>
            </select>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
<c-smart-table [columnSorter]="true" [columns]="columns" [columnFilter]="true" [itemsPerPageSelect]="true"
  [itemsPerPage]="10" [items]="DecisionParameters" [tableBodyProps]="{ align: 'middle' }"
  [tableProps]="{ hover: true, striped: true, responsive: true }" (rowClick)="rowSelected($event); " clickableRows
  header pagination>
</c-smart-table>
</div>
<div *ngIf="decisionSaveModel" class="save-model">
  <div class="main-height">
    <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
      <c-container fluid>
        <b>Update Decision Parameter</b>
        <button [cNavbarToggler]="toolbarCollapseRef"></button>
        <div #toolbarCollapseRef="cCollapse" navbar cCollapse>
          <c-navbar-nav class="me-auto mb-2 mb-lg-0">

          </c-navbar-nav>
          <form cForm class="d-flex" role="search">
            <button cTooltip="Go Back" cTooltipPlacement="top" style="margin: 5px;" cButton
              (click)="goBackToSearchScreen()"><svg cIcon name="cilChevronDoubleLeft"></svg></button>
            <button cTooltip="Save Customer" cTooltipPlacement="top" style="margin: 5px;" cButton
              (click)="submit()"><svg cIcon name="cilSave"></svg></button>
          </form>
        </div>
      </c-container>
    </c-navbar>
    <div class="row g-2 pt-4">
      <form [formGroup]="myForm">
        <div class="row">
          <div class="col-md-6">
            <label>Role Name</label>
            <div class="table-view">
              <input class="form-control" type="text" [(ngModel)]="getRowValueData.name" formControlName="name" />
            </div>
          </div>
          <div class="col-md-6">
            <label>Decision Type</label>
            <div class="table-view">
              <input type="text" class="form-control" [(ngModel)]="getRowValueData.decisionType"
                formControlName="decisionType" />
            </div>
          </div>
          <div class="col-md-6">
            <label>Decision Rule</label>
            <div class="table-view">
              <input type="text" class="form-control" [(ngModel)]="getRowValueData.decisionRule"
                formControlName="decisionRule" />
            </div>
          </div>
          <div class="col-md-6">
            <label>SourceType</label>
            <div class="table-view">
              <input type="text" class="form-control" [(ngModel)]="getRowValueData.sourceType"
                formControlName="sourceType" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-primary btn-sm add-button" (click)="add()">Add</button>
          </div>

          <div class="col-md-6">Source Key</div>
          <div class="col-md-6">Source Value</div>
        </div>

        <ng-container formArrayName='documents'>
          <fieldset *ngFor="let c of documentsControl.controls; let index = index" [formGroupName]='index'>
            <div class="row">
              <div class="col-md-4">
                <div class="table-view">
                  <input class="form-control" [readonly]="true" type="text" formControlName="key" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="table-view">
                  <input class="form-control" type="text" formControlName="value" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="table-view">
                <button class="btn danger-btn btn-sm"  (click)="removerow(index)">Remove</button>
                </div>
              </div>
             
            </div>

            <!-- <button *ngIf="c.value.key " class="btn btn-primary btn-sm" (click)="insert(index)">Insert</button> -->
            <!--<button class="btn btn-primary btn-sm" *ngIf="!c.value" (click)="remove(index)">Remove</button> -->
          </fieldset>
        </ng-container>
        <!--  <button type="submit" class="btn btn-primary btn-small">Submit</button> -->
      </form>


    </div>
  </div>
</div>